<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
         <div class="c-avatar mt-2">
          <img
            v-bind:src="getPhoto(datas.data)"
            class="c-avatar-img-profile mr-3"
          />
        </div>
      </CHeaderNavLink>
    </template>

    <CDropdownHeader
      tag="div"
      class="text-center"
      color="light"
    >
      <strong>Account</strong>
    </CDropdownHeader>

    <CDropdownItem @click="logout">
      <CIcon name="cil-lock-locked" /> Logout

    </CDropdownItem>
  </CDropdown>
</template>

<script>
import login from '@/services/login'
import axios from 'axios'

export default {
    mounted(){
      this.load()
    },
    computed : {
      isLoggedIn : function(){ return this.$store.getters.isLoggedIn}
    },
    methods: {
      logout: function () {
        return new Promise((resolve, reject) => {
            localStorage.removeItem('token')
            resolve()
        }).then(() => {
            this.$store.state.token = localStorage.getItem('token')
            this.$router.push('/login')
        })
      },
      load(){
          login.getLogin()
          .then(res => {
              this.datas = res;
          })

      },
      getPhoto(data){
        if (typeof data.people.member !== 'undefined' && data.people.member !== null) {
          data = data.people.member
          if (data.get_photo){
              return axios.defaults.baseURL + '/getfile/' + data.get_photo.path + '/' + data.get_photo.filename
          }else{
            return axios.defaults.baseURL + '/getfile/memberphoto/no_photo.jpg'
          }
        } else {
          return axios.defaults.baseURL + '/getfile/memberphoto/no_photo.jpg'
        }
      },
    },

  name: 'TheHeaderDropdownAccnt',
  data () {
    return {
      itemsCount: 42,
      datas:[],
    }
  }

}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>